import {
  validateURL,
  checkImageURL,
  validateIdString,
  validateIdsString,
  validateCountriesString,
  validateNonNegativeInteger,
} from './validate'

import { i18n } from '../lang'

const isNumber = evaluator => !Number.isNaN(+evaluator)

export const validateIsNumber = (rule, value, callback) => {
  if (!value) {
    return callback(i18n.t('error.thisFieldIsRequired'))
  }

  if (!isNumber(value)) {
    return callback(i18n.t('error.thisFieldMustBeANumber'))
  }

  return callback()
}

export const validateIsNonNegativeNumber = (rule, value, callback) => {
  if (!isNumber(value)) {
    return callback(i18n.t('error.thisFieldMustBeANumber'))
  }

  if (value < 0) {
    return callback(i18n.t('error.thisFieldMustBeAPositiveNumber'))
  }

  return callback()
}

export const validateIsPositiveNumber = (rule, value, callback) => {
  if (!value) {
    return callback()
  }

  if (!isNumber(value)) {
    return callback(i18n.t('error.thisFieldMustBeANumber'))
  }

  if (value <= 0) {
    return callback(i18n.t('error.thisFieldMustBeAPositiveNumber'))
  }

  return callback()
}

export const validateIsUrl = (rule, value, callback) => {
  if (!value) {
    return callback()
  }
  if (!validateURL(value)) {
    return callback(i18n.t('error.thisFieldShouldContainValidURL'))
  }
  return callback()
}

export const validateIsImageUrl = (rule, value, callback) => {
  if (!value) {
    return callback()
  }

  if (!checkImageURL(value)) {
    return callback(i18n.t('error.thisFieldShouldContainValidImageURL'))
  }

  return callback()
}

export const idsStringValidator = (rule, value, callback) => {
  const isValidFormat = validateIdsString(value)
  if (!isValidFormat) {
    callback(new Error(i18n.t('error.thereIsAnErrorInYourInputFormat')))
  } else {
    callback()
  }
}

export const noMoreThanTenIdValidator = (rule, value, callback) => {
  const isMoreThanaTenId = value.split(',').length > 11
  if (isMoreThanaTenId) {
    callback(new Error(i18n.t('error.noMoreThanTenId')))
  } else {
    callback()
  }
}

export const countriesStringValidator = (rule, value, callback) => {
  const isValidFormat = validateCountriesString(value)
  if (!isValidFormat) {
    callback(new Error(i18n.t('error.thereIsAnErrorInYourInputFormat')))
  } else {
    callback()
  }
}

export const positiveIntegerValidator = (rule, value, callback) => {
  if (value === '') {
    return callback()
  }

  if (!validateIdString(value)) {
    return callback(i18n.t('error.thisFieldMustBePositiveInteger'))
  }

  return callback()
}

export const nonNegativeIntegerValidator = (rule, value, callback) => {
  if (value === '') return callback()
  if (!validateNonNegativeInteger(value)) {
    return callback(i18n.t('error.thisFieldMustBeANonNegativeInteger'))
  }
  return callback()
}
